var _path, _path2, _path3, _path4, _path5;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgVivo({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 60,
    viewBox: "0 0 60 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.10426 40.6925C8.87624 40.6925 7.97837 40.5643 7.47957 39.6664L1.722 29.4339C1.13768 28.3508 1.82177 27.4244 2.44884 27.1964L3.97376 26.5123C4.80034 26.1418 5.78365 26.5266 6.15419 27.3959L9.75986 34.6784H9.81684L13.4368 27.3959C13.8073 26.5266 14.7906 26.1418 15.6172 26.5123L17.1421 27.1964C17.7549 27.4244 18.4533 28.3508 17.869 29.4339L12.1113 39.6664C11.7835 40.265 11.1708 40.664 10.4867 40.6925H9.09H9.10426Z",
    fill: "#66008B"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M34.4148 40.6925C33.7307 40.664 33.1179 40.265 32.7901 39.6664L27.0325 29.4339C26.4482 28.3508 27.1323 27.4244 27.7594 27.1964L29.2843 26.5123C30.1109 26.1418 31.0942 26.5266 31.4647 27.3959L35.0847 34.6784H35.1416L38.7615 27.3959C39.132 26.5266 40.1297 26.1418 40.942 26.5123L42.4669 27.1964C43.0798 27.4244 43.778 28.3508 43.1937 29.4339L37.4361 39.6664C37.1083 40.265 36.4955 40.664 35.8114 40.6925H34.4148Z",
    fill: "#66008B"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M25.2799 22.3218C25.2799 23.8752 24.0114 25.1436 22.458 25.1436C20.9046 25.1436 19.6362 23.8752 19.6362 22.3218C19.6362 20.7541 20.9046 19.5 22.458 19.5C24.0114 19.5 25.2799 20.7684 25.2799 22.3218Z",
    fill: "#66008B"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M51.317 26.4274C47.3551 26.4274 44.1343 29.6482 44.1343 33.6386C44.1343 37.629 47.3551 40.8499 51.317 40.8499C55.2789 40.8499 58.4998 37.629 58.4998 33.6386C58.4998 29.6482 55.2789 26.4274 51.317 26.4274ZM51.317 36.4747C49.7493 36.4747 48.481 35.192 48.481 33.6244C48.481 32.0567 49.7493 30.7883 51.317 30.7741C52.8847 30.7741 54.153 32.0424 54.153 33.6244C54.153 35.192 52.8847 36.4747 51.317 36.4747Z",
    fill: "#66008B"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.0068 28.3216C20.0068 27.3525 20.7906 26.5829 21.7455 26.5829H23.1992C24.154 26.5829 24.9378 27.3668 24.9378 28.3216V38.9532C24.9378 39.9224 24.154 40.6919 23.1992 40.6919H21.7455C20.7906 40.6919 20.0068 39.9081 20.0068 38.9532V28.3216Z",
    fill: "#66008B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVivo);
export default __webpack_public_path__ + "static/media/vivo.c1e6fa2ec776b1ecc531882637d7ec5e.svg";
export { ForwardRef as ReactComponent };